export const FETCHING_WHOLE_SALE_PLANNED = '@@toyota/FETCHING_WHOLE_SALE_PLANNED';
export const FETCHED_WHOLE_SALE_PLANNED = '@@toyota/FETCHED_WHOLE_SALE_PLANNED';
export const FETCHED_WHOLE_SALE_PLANNED_FAILED = '@@toyota/FETCHED_WHOLE_SALE_PLANNED_FAILED';

export const ADDING_WHOLE_SALE_PLANNED = '@@toyota/ADDING_WHOLE_SALE_PLANNED';
export const ADDED_WHOLE_SALE_PLANNED = '@@toyota/ADDED_WHOLE_SALE_PLANNED';
export const ADDED_WHOLE_SALE_PLANNED_FAILED = '@@toyota/ADDED_WHOLE_SALE_PLANNED_FAILED';
